import styled from 'styled-components';

const ChildMenu = styled.a`
    padding: 10px;
    text-decoration: none;
    cursor: pointer;
    border-radius: 8px;
    background: ${props => props.active ? "#EBECF0" : "transparent"};
    &:hover{
        background: #EBECF0;
    }
`;

export default ChildMenu;